// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"f95e2c1c29aa07efc56f","691":"3b0a3182e689a477a8e8"}[chunkId] + ".js";
};